const getToastPosition = isMobile => {
  const data = {
    top: 'calc(100% - 10%)',
    left: '2%',
    width: '100%',
    zIndex: 9999
  };
  if (isMobile) {
    data.top = 'calc(100% - 46px)';
    data.left = 'calc(100% - 359px)';
  }
  return data;
};

export { getToastPosition };
